"use client";

import Link from "next/link";
import { useI18n } from "@/lib/i18n";

export function Footer() {
	const { t } = useI18n();
	const year = new Date().getFullYear();

	return (
		<footer data-nav="dark" className="bg-ink text-white pb-5 pt-10">
			<div className="mx-auto max-w-[1200px] px-[clamp(20px,4vw,48px)] min-[1600px]:max-w-[1400px]">
				<div className="grid grid-cols-[auto_minmax(0,1fr)_auto] gap-x-8 max-sm:grid-cols-[auto_minmax(0,1fr)] max-sm:gap-x-4">
					<div className="max-sm:hidden" />
					<div className="flex justify-between gap-10 text-[15px] leading-normal max-sm:col-span-2 max-sm:gap-6">
						<div className="flex flex-col gap-1.5 text-left">
							<span className="text-[12px] font-semibold uppercase tracking-[0.12em] text-primary-200">
								POLS Engineering ehf.
							</span>
							<span>{t("footer.street")}</span>
							<span>400 Ísafjörður</span>
						</div>

						<div className="flex flex-col gap-1.5 text-left">
							<Link
								href="/contact"
								className="text-[12px] font-semibold uppercase tracking-[0.12em] text-primary-200 no-underline transition-colors duration-200 hover:text-white"
							>
								{t("home.contact")}
							</Link>
							<a
								href="mailto:orn@snowsense.is"
								className="text-white no-underline transition-colors duration-200 hover:text-primary-200"
							>
								orn@snowsense.is
							</a>
						</div>
					</div>
					<div className="max-sm:hidden" />

					<div className="col-span-3 mt-6 border-t border-white/[.12] max-sm:col-span-2" />

					<span className="pt-4 text-[16px] font-semibold italic uppercase tracking-[0.02em] max-sm:col-span-2">
						{t("home.snowsense")}
					</span>
					<span className="pt-4 text-center text-[13px] text-primary-200 max-sm:col-span-2 max-sm:pt-1.5 max-sm:text-left">
						{t("footer.tagline")}
					</span>
					<span className="whitespace-nowrap pt-4 text-right text-[13px] text-primary-200 max-sm:col-span-2 max-sm:pt-3 max-sm:text-left">
						© {year} POLS Engineering ehf.
					</span>
				</div>
			</div>
		</footer>
	);
}
